import React from 'react';
import PropTypes from 'prop-types';

const FilterPill = ({ filter, label, remove }) => (
  <div className="label bg-medium-gray br-max pl-s pr-xs mr-xs mb-xs">
    <span style={{ textTransform: 'capitalize' }} className="white">{filter}: {label}</span>
    <span className="ml-xs badge bg-white cursor-pointer" role="button" tabIndex={0} onClick={remove}>
      <i className="material-icons fs-s medium-gray">close</i>
    </span>
  </div>
);

FilterPill.propTypes = {
  filter: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  remove: PropTypes.func.isRequired,
};

export default FilterPill;
